<template>
  <div>
    <b-modal
      title="更改密碼"
      size="lg"
      centered
      hide-footer
      header-class="head-modal"
      v-model="modalShow"
    >
      <b-form-group label-cols="auto" label-cols-lg="auto" label="舊密碼" class="mb-4">
        <b-form-input v-model="form.old_password"></b-form-input>
      </b-form-group>

      <b-form-group label-cols="auto" label-cols-lg="auto" label="新密碼" class="mb-4">
        <b-form-input v-model="form.password"></b-form-input>
      </b-form-group>

      <b-form-group label-cols="auto" label-cols-lg="auto" label="確認密碼">
        <b-form-input v-model="form.password_check" @input="shouldCheckPassword = true" :state="resetVaCheck"></b-form-input>

        <b-form-invalid-feedback :state="resetVaCheck">需與新密碼需一致</b-form-invalid-feedback>
      </b-form-group>

      <div class="text-center mt-4">
        <b-button
          class="mr-2"
          variant="success"
          size="sm"
          @click="sumit()"
        >
          確定
        </b-button>

        <b-button
          variant="danger"
          size="sm"
          @click="$emit('change', false)"
        >
          取消
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import baseApi from "@/models/API/baseApi";

export default {
  name: 'UpdatePasswordModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  components: {

  },
  data () {
    return {
      form: {
        old_password: '',
        password: '',
        password_check: ''
      },
      shouldCheckPassword: false
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
    resetVaCheck() {
      let status = null;

      if (!this.shouldCheckPassword) status = null
      else if (this.shouldCheckPassword && (this.form.password === this.form.password_check)) status = true
      else status = false

      return status;
    },
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) this.resetData();
      },
      immediate: false
    }
  },
  mounted() {
    this.baseApi = new baseApi();
  },
  methods: {
    sumit() {
      try {
        let required =
          ['old_password',
          'password',
          'password_check'];
        const form = this.form;
        const status = required.every(item => {
          return Array.isArray(form[item]) ? form[item].length !== 0 : form[item] != null && form[item] !== '';
        });

        if (!status) {
          throw { message: '欄位請填寫完整', title: '更改密碼' };
        } else if (!this.resetVaCheck) {
          throw { message: '需與新密碼需一致', title: '更改密碼' };
        }
    
        this.$emit('sumit', form);
      } catch(message) {
        this.baseApi.toast(() => {}, message, false);
      }
    },
    // 重置資料
    resetData() {
      this.form = {
        old_password: '',
        password: '',
        password_check: ''
      };

      this.shouldCheckPassword = null;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/UpdatePasswordModal.vue